import React, { ReactNode } from 'react';
import { Element } from '@/components/card/CardFooter/CardFooter.styles';

export interface CardFooterProps {
  className?: string;
  children?: ReactNode;
}

const CardFooter = ({ children, ...props }: CardFooterProps) => {
  return <Element>{children}</Element>;
};

export default CardFooter;
